import React, { useState, useEffect } from "react";
import axios from "axios";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
import { baseUrl } from "../../../api/common";

const GstAdd = ({
  fetchGstData,
  addPopupStatus,
  handleAddPopup,
  eventType,
  updateData,
}) => {
  const [updateId, setUpdateId] = useState("");

  const [formValues, setFormValues] = useState({
    gst_type: "",
    gst_value: "",
  });

  const [errors, setErrors] = useState({
    gstType: "",
    gstValue: "",
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      gstType: "",
      gstValue: "",
    };
    if (!formValues.gst_type) {
      newErrors.gstType = "Gst type cannot be empty";
    }
    if (!formValues.gst_value.trim()) {
      newErrors.gstValue = "Gst value cannot be empty";
    }
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const clearInputValues = () => {
    setErrors({
      gstType: "",
      gstValue: "",
    });
    setFormValues({
      gst_type: "",
      gst_value: "",
    });
    handleAddPopup(false);
  };

  const [gstTypeData, setGstTypeData] = useState([]);

  const fetchGstTypeData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_gst_type`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        setGstTypeData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const addUpdateGst = async () => {
    if (validate()) {
      console.log("Post Data:", formValues);
      try {
        const requestData = {
          ...formValues,
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/add_gst`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem("access_token"),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, "success");
          fetchGstData();
          clearInputValues();
        } else {
          showToast(response.data.message, "error");
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  useEffect(() => {
    fetchGstTypeData();
  }, []);

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        gst_type: updateData.gst_type || "",
        gst_value: updateData.gst_value || "",
      });
    } else {
      setErrors({
        gstType: "",
        gstValue: "",
      });
      setFormValues({
        gst_type: "",
        gst_value: "",
      });
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
      <ToastMessage />
      {addPopupStatus && (
        <div
          className={`extraspace_search_div search_div${
            addPopupStatus ? " open" : ""
          }`}
        >
          <div className="card member_master_sidebar_scrool">
            <div className="member_edit_pop_flex mb-3 text-end">
              <h3>{eventType} GST</h3>
              <div className="input-group-append">
                <span
                  onClick={() => clearInputValues()}
                  className="search_toggle btn btn-danger"
                >
                  <i className="fa fa-times" />
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <div className="body application_body_side">
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>GST Type</label>
                        <select
                          className={`form-control ${
                            errors.gstValue ? "red_border" : ""
                          }`}
                          value={formValues.gst_type}
                          onChange={(e) =>
                            handleInputChange("gst_type", e.target.value)
                          }
                          displayEmpty
                        >
                          <option value="">-- Select Gst Type--</option>
                          {gstTypeData.length > 0 ? (
                            gstTypeData.map((data) => (
                              <option key={data.id} value={data.id.toString()}>
                                {data.gst_type_name}
                              </option>
                            ))
                          ) : (
                            <option disabled>No data available</option>
                          )}
                        </select>
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.gstType}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>GST Value</label>
                        <input
                          type="number"
                          className={`form-control ${
                            errors.gstValue ? "red_border" : ""
                          }`}
                          value={formValues.gst_value}
                          onChange={(e) =>
                            handleInputChange("gst_value", e.target.value)
                          }
                          required
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.gstValue}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 member_button_flex">
                      <button
                        onClick={() => addUpdateGst()}
                        className="btn btn-outline-info"
                      >
                        {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GstAdd;
